import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pantalla-actos',
  templateUrl: './pantalla-actos.component.html',
  styles: []
})
export class PantallaActosComponent implements OnInit {

  private _egreso2019: string[] = [];
  private _egreso2020: string[] = [];

  // variables de visibilidad
  actos2019 = false;
  actos2020 = false;

  constructor() { }

  ngOnInit() {
    this.CargarFotos();
  }

  get Egreso2019(): string[]{
    return this._egreso2019;
  }

  get Egreso2020(): string[]{
    return this._egreso2020;
  }

  mostrarAno2019(){
    this.actos2019 ? this.actos2019 = false : this.actos2019 = true;
    this.actos2020 = false;
  }

  mostrarAno2020(){
    this.actos2020 ? this.actos2020 = false : this.actos2020 = true;
    this.actos2019 = false;
  }

  // llenado de Variables
  private CargarFotos(){  
    console.log("CargarFotos 1");  

    //2019
    let o = 1;
    for(let i = 0; i<20; i++){
      let foto = "ActoFinAño2019 ("+o+").jpg"
      console.log("1 = " + i);  
      this._egreso2019.push(foto);
      o++;
    }  

    //2020    
    o = 1;
    for(let i = 0; i<16; i++){
      let foto = "ActoFinAno2020 ("+o+").jpg"
      console.log("1 = " + i);  
      this._egreso2020.push(foto);
      o++;
    } 
  }

}
